import resume from '../assets/pdf/resume.pdf'
import photo from '../assets/png/image.png'
export const headerData = {
    name: 'Sudhanshu Patil',
    title: "Software Developer / ML Enthusiast",
    desciption:"With a keen interest in machine learning and a knack to solve complex problems, I possess a foundation in C++, Python and C, with a touch of familiarity in Java. Eager to broaden my horizons across various computer science fields and passionate about learning more, I am open to embracing diverse roles that come my way.  ",
    image: photo,
    resumePdf: resume
}
